import { gql } from '@apollo/client';

export const GET_COACH_GROUP = gql`
  query getCoachGroup($getCoachGroupInput: GetCoachGroupInput!) {
    getCoachGroup(getCoachGroupInput: $getCoachGroupInput) {
      id
      principalCoach {
        id
        firstName
        lastName
        email
        role
        profilePic
        brandTag
        organizationId
        lastSeanTime
        tp
      }
      coaches {
        id
        firstName
        lastName
        email
        role
        profilePic
        isActive
        archived
        brandTag
        organizationId
        lastSeanTime
        tp
      }
      totalCount
    }
  }
`;

export const GET_COACH_GROUP_MEMBERS = gql`
  query getCoachGroupMembers($archived: Boolean!, $take: Int!, $skip: Int!, $filterText: String) {
    getCoachGroupMembers(archived: $archived, take: $take, skip: $skip, filterText: $filterText) {
      coaches {
        id
        firstName
        lastName
        email
        role
        profilePic
        isActive
        archived
        brandTag
        organizationId
        lastSeanTime
        tp
        isPrincipalCoach
      }
      totalCount
    }
  }
`;

export const ADD_COACH_TO_GROUP = gql`
  mutation assignCoachToGroup($input: AddCoachToGroupInput!) {
    assignCoachToGroup(input: $input) {
      id
      principalCoach {
        id
        firstName
        lastName
        email
        role
        profilePic
        brandTag
        organizationId
        tp
      }
      coaches {
        id
        firstName
        lastName
        email
        role
        profilePic
        isActive
        archived
        brandTag
        organizationId
        tp
      }
      totalCount
    }
  }
`;

export const EDIT_TEAM_MEMBER = gql`
  mutation editTeamMemberData($editTeamMemberDataInput: EditTeamMemberDataInput!) {
    editTeamMemberData(editTeamMemberDataInput: $editTeamMemberDataInput) {
      id
      principalCoach {
        id
        firstName
        lastName
        email
        role
        profilePic
        brandTag
        organizationId
        tp
      }
      coaches {
        id
        firstName
        lastName
        email
        role
        profilePic
        isActive
        archived
        brandTag
        organizationId
        tp
      }
      totalCount
    }
  }
`;
